import {
  Alert,
  Box,
  Button,
  Container,
  FormControl,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAddGoogleUserMutation } from "../users/usersApiSlice";

import { useDispatch } from "react-redux";
import { setCredentials } from "./authSlice";
import { useGoogleLoginMutation } from "./authApiSlice";
import Spinner from "../../components/Spinner";

const Username = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [googleLogin] = useGoogleLoginMutation();

  const userRef = useRef();
  const errRef = useRef();
  const [username, setUsername] = useState("");
  const [errMsg, setErrMsg] = useState("");

  const [addGoogleUser, { isLoading }] = useAddGoogleUserMutation();

  const { firstName, lastName, email, picture, googleId } =
    location.state || {};

  useEffect(() => {
    // Check if location.state is null or undefined
    if (!location.state) {
      // Redirect to another page (e.g., home page)
      navigate("/login");
    }
  }, [location, navigate]);

  useEffect(() => {
    // console.log(400, location.state);
    if (!location.state) {
      //   console.log(300);
      // Redirect to another page (e.g., home page)
      navigate("/");
    }
    userRef?.current?.focus();
  }, []);

  useEffect(() => {
    if (username !== "") {
      setErrMsg("");
    }
  }, [username]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Get username, store user details & redirect to home page
    try {
      const addUser = await addGoogleUser({
        firstName,
        lastName,
        username,
        email,
        picture,
        googleId,
      }).unwrap();

      if (addUser) {
        const { accessToken } = await googleLogin({ username, email }).unwrap();
        dispatch(setCredentials({ accessToken }));
        navigate("/", { state: null, replace: true });
      }
    } catch (err) {
      if (!err.status) {
        setErrMsg("No Server Response");
      } else if (err.status === 400) {
        setErrMsg("Missing Username");
      } else if (err.status === 409) {
        setErrMsg(err.data?.message);
      } else {
        setErrMsg(err.data?.message);
      }
    }
  };

  const handleUserInput = (e) => setUsername(e.target.value);

  const buttonRef = useRef(null);

  // Handle the "Enter" key down in the username input field
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      buttonRef.current.click(); // Trigger the button click
    }
  };

  if (isLoading) return <Spinner />;

  return (
    <Container sx={{ marginY: 10 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper elevation={5} sx={{ minWidth: 400, padding: 3 }} span={3}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            {errMsg && (
              <Alert
                variant="outlined"
                severity="error"
                ref={errRef}
                aria-live="assertive"
              >
                {errMsg}
              </Alert>
            )}
            <Typography variant="h4" component="h1">
              Add Username
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <FormControl>
                <TextField
                  type="text"
                  label="Username"
                  id="username"
                  inputRef={userRef}
                  color="inherit"
                  onChange={handleUserInput}
                  onKeyDown={handleKeyDown}
                  value={username}
                  autoComplete="off"
                  required
                />
              </FormControl>

              <Button
                variant="outlined"
                color="inherit"
                size="large"
                onClick={handleSubmit}
                ref={buttonRef}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Username;
